import { DEPRECATED_POI_MANUFACTURER_KEYWORD_SLUGS, POI_MANUFACTURER_KEYWORDS, POI_RENTAL_TYPE_KEYWORDS, POI_RENTAL_TYPE_KEYWORDS_EN_TO_FR, POI_RENTAL_TYPE_KEYWORDS_FR_TO_EN } from '~/constants/keywords'
import type { SupportedLocales } from '#shared/types/locales'

export default defineNuxtRouteMiddleware((to) => {
  const keywordTranslated: Record<SupportedLocales, Record<string, string>> = {
    fr: POI_RENTAL_TYPE_KEYWORDS_EN_TO_FR,
    en: POI_RENTAL_TYPE_KEYWORDS_FR_TO_EN,
  }

  function getTranslatedKeyword(keyword: string, locale: string) {
    return keywordTranslated?.[locale as SupportedLocales]?.[keyword]
  }

  const { $i18n } = useNuxtApp()

  const localePath = useLocalePath()
  const getRouteBaseName = useRouteBaseName()

  const keyword = Array.isArray(to.params?.keyword) ? to.params?.keyword.join(' ') : to.params?.keyword

  if (keyword) {
    const destinationPath = to.params?.destinationPath
    /**
     * If the keyword is translated, redirect to the translated keyword page
     */
    const translatedKeyword = getTranslatedKeyword(keyword, $i18n.locale.value)
    if (translatedKeyword && translatedKeyword !== keyword) {
      const name = getRouteBaseName(to)?.toString() ?? ''
      return navigateTo(localePath({ name, params: { keyword: translatedKeyword, destinationPath } }), {
        redirectCode: 301,
      })
    }

    const isSupportedKeyword = [...POI_RENTAL_TYPE_KEYWORDS, ...Object.keys(POI_MANUFACTURER_KEYWORDS)].includes(keyword)
    if (!isSupportedKeyword) {
      /**
       * If the keyword existed in the past, return a 410 code.
       */

      if (DEPRECATED_POI_MANUFACTURER_KEYWORD_SLUGS.includes(keyword)) {
        return createError({
          statusCode: 410,
          statusMessage: 'Keyword not found',
        })
      }

      /**
       * Otherwise, return a 404 error on the keyword page
       */
      return createError({
        statusCode: 404,
        statusMessage: 'Keyword not found',
      })
    }
  }
})
